module.exports = __webpack_public_path__ + "lb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/lb.svg
// module id = 911
// module chunks = 0